export default __webpack_public_path__ + "static/media/Near Me.dc36f041.png";